import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray"; //@ts-check

import pathUtil from '../../../../../../../utils/pathUtil';
import * as edxUtils from '../../edxUtils';
/** This file is to be used to anything edm output related */

/**
 * Add data source to output
 * @param {import('./types').DasJob} job The diagram content
 * @param {import('./types').CsvUrl} csvUrl The data source to add to output content
 */

export var addToOutput = function addToOutput(job, csvUrl) {
  var existingAttributes = [];
  /**@type {import('./types').DasElementSequence} */

  var elementSequence = {
    id: getNextId(job),
    name: getValidXmlElementName(pathUtil.getFileCaption(csvUrl.src)),
    dataSource: csvUrl.id,
    disableNamespace: 'true',
    elementName: 'elementSequence',
    attributes: csvUrl.fields.map(function (field) {
      return {
        id: getNextId(job),
        name: function () {
          // collect all new attributes to make sure there are no duplicates
          var validNewName = getValidXmlAttributeName(field.name, existingAttributes);
          existingAttributes.push(validNewName);
          return validNewName;
        }(),
        value: field.id
      };
    }),
    elements: []
  };
  job.output.element.elements.push(elementSequence);
};
/**
 * Remove data source from output.
 * @param {import('./types').DasJob} job The diagram content
 * @param {string} dataSourceId The id of the datasource
 */

export var removeFromOutput = function removeFromOutput(job, dataSourceId) {
  // remove any relationships of this table
  // get the output element connected to this data source
  // which may be connected with a filter
  var outputElement = edxUtils.getDescendants(job.output.element).find(function (descendant) {
    var initialDataSource = edxUtils.getInitialDataSource(job, descendant);
    return initialDataSource && initialDataSource.id === dataSourceId;
  });

  if (outputElement) {
    removeRelationship(job, outputElement.id); // changing the original array is not permitted during a foreach loop

    var childElements = _toConsumableArray(outputElement.elements);

    childElements.forEach(function (element) {
      return removeRelationship(job, element.id);
    });
    edxUtils.removeElement(job.output.element, outputElement.id);
  }
};
/**
 * Remove relationship between two data sources.
 * @param {import("./types").DasJob} job The diagram content
 * @param {string} relationshipId The id of the relationship
 */

export var removeRelationship = function removeRelationship(job, relationshipId) {
  var element = edxUtils.getDescendant(job.output.element, relationshipId);
  if (!element) return;
  var elementDataSource = edxUtils.getDataSource(job, element.dataSource); // if the data source is not a filter function
  // the element will be moved to root as is

  if (elementDataSource.elementName === 'equalFilterFunction') {
    edxUtils.removeDataSource(job, elementDataSource.id); // use data source directly

    element.dataSource = elementDataSource.dataSource;
  } // move element to root


  edxUtils.removeElement(job.output.element, element.id);
  job.output.element.elements.push(element);
};
/**
 * Update a relationship between two data sources.
 * @param {import("./types").DasJob} job The diagram content
 * @param {object} values The id of the relationship
 */

export var updateRelationship = function updateRelationship(job, values) {
  removeRelationship(job, values.destinationTable);
  var destinationElement = edxUtils.getDescendant(job.output.element, values.destinationTable); // Need to make destination table as child of the source table.
  // To avoid a loop if source table is child of destination table
  // also remove relationship of source table

  if (edxUtils.getDescendant(destinationElement, values.sourceTable)) {
    removeRelationship(job, values.sourceTable);
  } // move destination under source element


  edxUtils.removeElement(job.output.element, destinationElement.id);
  var sourceElement = edxUtils.getDescendant(job.output.element, values.sourceTable);
  sourceElement.elements.push(destinationElement); // add destination data source filter

  /** @type {import('./types').EqualFilterFunction} */

  var dataSourceFilter = {
    id: getNextId(job),
    dataSource: destinationElement.dataSource,
    field: values.destinationColumn,
    parentField: values.sourceColumn,
    elementName: 'equalFilterFunction'
  };
  job.dataSources.push(dataSourceFilter);
  destinationElement.dataSource = dataSourceFilter.id;
  var nextPosition = getNextCorrectItemPosition(20, job.diagram.items);
  job.diagram.items.push({
    id: dataSourceFilter.id,
    x: nextPosition,
    y: nextPosition,
    height: 100,
    width: 150,
    elementName: 'diagramEqualFilterFunction'
  });
};

var getNextCorrectItemPosition = function getNextCorrectItemPosition(step, items) {
  var current = 10;

  while (items.some(function (e) {
    return parseFloat(e.x) === current && parseFloat(e.y) === current;
  })) {
    current += step;
  }

  return current.toString();
};

var getValidXmlElementName = function getValidXmlElementName(name, defaultName) {
  var validCharsReg = /[A-Za-z0-9-_]+/g;
  var invalidStartReg = /^[0-9-]+/; // remove invalid chars

  var result = name.match(validCharsReg).join(''); // remove invalid chars at the begining of the element

  var invalidStartMatch = result.match(invalidStartReg);
  if (invalidStartMatch !== null) result = result.substring(invalidStartMatch[0].length + 1);
  if (!result) result = defaultName;
  return result;
};

var getValidXmlAttributeName = function getValidXmlAttributeName(name, existingAttributes) {
  var validName = getValidXmlElementName(name);
  var index = 0;
  var currentName = validName;

  while (existingAttributes.some(function (attribute) {
    return attribute.name === currentName;
  })) {
    index++;
    currentName = validName + index;
  }

  return currentName;
};

var getNextId = function getNextId(job) {
  var nextId = parseInt(job.lastId) + 1;
  job.lastId = nextId.toString();
  return job.lastId;
};